
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { _getURL } from "@/api/index";
import React, { useState } from 'react';
import _ from 'lodash';

import { RightButtonIcon, LeftButtonIcon } from "@/components/common/icon";
import { useMediaQuery } from "@mantine/hooks";
  
const _handleDownloadClick = () => {
    const userAgent =
      typeof window !== "undefined"
        ? navigator.userAgent || navigator.vendor || window.opera
        : "";
  
    const isAppleDevice = /Mac|iPhone|iPad|iPod/i.test(userAgent);
  
    if (isAppleDevice) {
      window.open(
        "https://apps.apple.com/my/app/keyauto-malaysia-wek4u/id6670432545",
        "_blank"
      );
    } else {
      window.open(
        "https://play.google.com/store/apps/details?id=my.keyauto.WeK4U",
        "_blank"
      );
    }
};


const MobileView = (props) => {
    const { t, reviews } = props;
    
    const [startIndex, setStartIndex] = useState(0);
    const itemsPerPage = 1;
    
    const visibleReviews = reviews.slice(startIndex, startIndex + itemsPerPage);

    const handlePrev = () => {
        if (startIndex > 0) setStartIndex(startIndex - 1);
    };
    
    const handleNext = () => {
        if (startIndex + itemsPerPage < reviews.length)
        setStartIndex(startIndex + 1);
    };

    return (
        <div className='keywash'>
            <div className='keywash-top'>
                <div className='keywash-top-background'>
                    <img src='/assets/images/keywash/keywash-bg.png' alt='keywash-bg' />
                </div>
                <div className='keywash-top-image'>
                    <img src='/assets/images/keywash/keywash-top.png' alt='car-keywash' />
                </div>
                <div className='keywash-top-content'>
                    <h3 dangerouslySetInnerHTML={{ __html: t('keywash_title') }}/>
                    <p>{t('keywash_subtitle')}</p>
                    <div className='keywash-store'>
                        <a href='https://play.google.com/store/apps/details?id=my.keyauto.WeK4U' target='_blank'><img src='/assets/images/playstore.png' alt='playstore' /></a>
                        <a href='https://apps.apple.com/my/app/keyauto-malaysia-wek4u/id6670432545' target='_blank'><img src='/assets/images/appstore.png' alt='appstore' /></a>
                    </div>
                </div>
                
            </div>
            <div className='keywash-content'>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/car-wash.png' alt='car-wash' />
                    </div>
                    <h4>{t('touchless')}</h4>
                    <p>{t("safe_for_paint")}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/list.png' alt='list' />
                    </div>
                    <h4>{t('transparent')}</h4>
                    <p>{t("pricing_packages")}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/24-hours.png' alt='clock' />
                    </div>
                    <h4>24/7</h4>
                    <p>{t('availability')}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/time.png' alt='time' />
                    </div>
                    <h4>{t("quick_wash")}</h4>
                    <p>{t("in_mins")}</p>
                </div>
            </div>
            <div className="keywash-content-2">
                <div className="keywash-content-2-bg">
                    <img src='/assets/images/keywash/keywash-content.png' alt='how-it-works' />
                </div>
                <div className="keywash-content-2-item">
                    <h4>{t('how_it_works')}</h4>
                    <div className='step'>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                        <h5>01</h5>
                        <p>{t("step_1")}</p>
                        <h5></h5>
                    </div>
                    <div className='step-reverse'>
                        <h5></h5>
                        <p>{t("step_2")}</p>
                        <h5>02</h5>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                    </div>
                    <div className='step'>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                        <h5>03</h5>
                        <p>{t("step_3")}</p>
                        <h5></h5>
                    </div>
                </div>
            </div>
            <div className="keywash-review">
                <h3>{t("what_customer_say")}</h3>
                <div className="keywash-review-list">
                {visibleReviews.map((item, idx) => (
                    <div className="keywash-review-item" key={idx}>
                    <p className="review">"{item.review}"</p>
                    <p className="username">{item.username}</p>
                    </div>
                ))}
                </div>
                <div className="review-nav">
                    <div onClick={handlePrev}>
                        <LeftButtonIcon disable={startIndex == 0? true : false} />
                    </div>
                    <div onClick={handleNext}>
                        <RightButtonIcon disable={startIndex + itemsPerPage < reviews.length ? false : true}/>
                    </div>
                    
                </div>
            </div>
            <div className='keywash-bottom'>
                <p>{t("download_desc")}</p>
                <button className="download" onClick={_handleDownloadClick}>{t("download_app")}</button>
            </div>
        </div>
    )
}

const DesktopView = (props) => {
    const { t, reviews } = props;
    
    const [startIndex, setStartIndex] = useState(0);
    const itemsPerPage = 3;

    const visibleReviews = reviews.slice(startIndex, startIndex + itemsPerPage);
    
    const handlePrev = () => {
        if (startIndex > 0) setStartIndex(startIndex - 1);
    };
    
    const handleNext = () => {
        if (startIndex + itemsPerPage < reviews.length)
        setStartIndex(startIndex + 1);
    };

    return (
        <div className='keywash'>
            <div className='keywash-top'>
                <div className='keywash-top-background'>
                    <img src='/assets/images/keywash/keywash-bg.png' alt='keywash-bg' />
                </div>
                <div className='keywash-top-image'>
                    <img src='/assets/images/keywash/keywash-top.png' alt='car-keywash' />
                </div>
                <div className='keywash-top-content'>
                    <h3 dangerouslySetInnerHTML={{ __html: t('keywash_title') }}/>
                    <p>{t('keywash_subtitle')}</p>
                    <div className='keywash-store'>
                        <a href='https://play.google.com/store/apps/details?id=my.keyauto.WeK4U' target='_blank'><img src='/assets/images/playstore.png' alt='playstore' /></a>
                        <a href='https://apps.apple.com/my/app/keyauto-malaysia-wek4u/id6670432545' target='_blank'><img src='/assets/images/appstore.png' alt='appstore' /></a>
                    </div>
                </div>
                
            </div>
            <div className='keywash-content'>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/car-wash.png' alt='car-wash' />
                    </div>
                    <h4>{t('touchless')}</h4>
                    <p>{t("safe_for_paint")}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/list.png' alt='list' />
                    </div>
                    <h4>{t('transparent')}</h4>
                    <p>{t("pricing_packages")}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/24-hours.png' alt='clock' />
                    </div>
                    <h4>24/7</h4>
                    <p>{t('availability')}</p>
                </div>
                <div className='keywash-content-item'>
                    <div className='icon'>
                        <img src='/assets/images/keywash/time.png' alt='time' />
                    </div>
                    <h4>{t("quick_wash")}</h4>
                    <p>{t("in_mins")}</p>
                </div>
            </div>
            <div className="keywash-content-2">
                <div className="keywash-content-2-bg">
                    <img src='/assets/images/keywash/keywash-content.png' alt='how-it-works' />
                </div>
                <div className="keywash-content-2-item">
                    <h4>{t('how_it_works')}</h4>
                    <div className='step'>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                        <h5>01</h5>
                        <p>{t("step_1")}</p>
                        <h5></h5>
                    </div>
                    <div className='step-reverse'>
                        <h5></h5>
                        <p>{t("step_2")}</p>
                        <h5>02</h5>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                    </div>
                    <div className='step'>
                        <img src='/assets/images/keywash/transparent_square.png' alt='box' />
                        <h5>03</h5>
                        <p>{t("step_3")}</p>
                        <h5></h5>
                    </div>
                </div>
            </div>
            <div className="keywash-review">
                <h3>{t("what_customer_say")}</h3>
                <div className="keywash-review-list">
                {visibleReviews.map((item, idx) => (
                    <div className="keywash-review-item" key={idx}>
                    <p className="review">"{item.review}"</p>
                    <p className="username">{item.username}</p>
                    </div>
                ))}
                </div>
                <div className="review-nav">
                    <div onClick={handlePrev}>
                        <LeftButtonIcon disable={startIndex == 0? true : false} />
                    </div>
                    <div onClick={handleNext}>
                        <RightButtonIcon disable={startIndex + itemsPerPage < reviews.length ? false : true}/>
                    </div>
                    
                </div>
            </div>
            <div className='keywash-bottom'>
                <p>{t("download_desc")}</p>
                <button className="download" onClick={_handleDownloadClick}>{t("download_app")}</button>
            </div>
        </div>
    )
}
export default function Index(props) {
    const { t, device, session } = props;
    const isMobile = useMediaQuery('(max-width: 1024px)', true, { getInitialValueInEffect: true });

    const reviews = [
        { review: "I got the monthly pass and it’s a lifesaver. My car looks clean all the time and I save a lot compared to paying one by one.", username: "Kelvin T." },
        { review: "Super convenient! I don’t need to line up at petrol station washes anymore. Just book in the app, drive in, and I’m done in minutes.", username: "Jason L." },
        { review: "Love how smooth the app is. Prices are clear, no surprises, and the touchless wash keeps my car paint safe. Definitely worth it.", username: "Aisha R." },
    ];
    

    props = {
        reviews, ...props
    }

    return (
        isMobile ? <MobileView {...props} /> : <DesktopView {...props} />
    );
}

Index.newLayout = function newLayout(page)
 {
    return ( 
        <>
            {page}
        </>
    )
}


export async function getStaticProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}